<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-file-exclamation', fontSet: 'fad'}"
	[headerText]="T.DIALOG_TITLE_PROCEDURE_AND_REASONING | translate"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
	[overflowHandledByChild]="true"
>
	<mat-tab-group dialogContent>
		<mat-tab>
			<ng-template mat-tab-label>
				<mat-icon class="matTabIcon" inline fontSet="fad" fontIcon="fa-memo-circle-info" />
				{{ T.ASSESSMENT_ITEM_PROCEDURE | translate }}
			</ng-template>

			<sim-rich-text-editor-view [content]="data.item.procedure" />
		</mat-tab>

		<mat-tab>
			<ng-template mat-tab-label>
				<mat-icon class="matTabIcon" inline fontSet="fad" fontIcon="fa-lightbulb-on" />
				{{ T.ASSESSMENT_ITEM_HINTS_AND_REASONING | translate }}
			</ng-template>
			<sim-rich-text-editor-view [content]="data.item.hintsAndReasoning" />
		</mat-tab>
	</mat-tab-group>
</sim-basic-material-dialog>
